import { render, staticRenderFns } from "./HouseList.vue?vue&type=template&id=6c080b2f&scoped=true"
import script from "./HouseList.vue?vue&type=script&lang=js"
export * from "./HouseList.vue?vue&type=script&lang=js"
import style0 from "./HouseList.vue?vue&type=style&index=0&id=6c080b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c080b2f",
  null
  
)

export default component.exports